import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { UserService } from "../../services/UserService";

export interface IRenderOnAuthenticatedProps {
  children: ReactElement;
}

export const RenderOnAuthenticated: React.FC<IRenderOnAuthenticatedProps> = ({
  children,
}) => {
  return UserService.isLoggedIn() ? children : <Navigate to="/" />;
};
